if (!customElements.get('product-sticky-add-to-cart')) {
  class TG_ProductStickyAddToCart extends HTMLElement {
    constructor() {
      super();

      this.startElement = document.querySelector(".Product__Block--buyButtons");
      this.endElement = document.querySelector(".shopify-section--footer");
      if(this.startElement && this.endElement){
        this.intersectionObserver = new IntersectionObserver(this._revealAddToCartButton.bind(this), {
          threshold: 0.3
        });

        this.intersectionObserver.observe(this.startElement);
        this.intersectionObserver.observe(this.endElement);
      }
    }

    connectedCallback() {
      this.delegateElement = new themegoal.libs.Delegate(this);
      this.delegateElement.on('click', '[data-action="sticky-add-to-cart"]', this._addToCart.bind(this));
    }

    disconnectedCallback(){
      if(this.delegateElement)this.delegateElement.destroy();
    }

    _revealAddToCartButton(entries){
      var _this = this;
      entries.forEach(function (entry) {
        if(entry.target === _this.startElement){
          _this.isStartElementOutOfView = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        }

        if(entry.target === _this.endElement){
          _this.isEndElementInView = entry.isIntersecting && entry.boundingClientRect.top < window.innerHeight;
        }
      });

      this.classList.toggle("Visible", this.isStartElementOutOfView && !this.isEndElementInView);
    }

    _addToCart(event) {
      let _this = this;
  
      event.preventDefault(); 
  
      let formElement = this.querySelector('form.ProductStickyAddToCartForm');
  
      let addToCartButton = this.querySelector('.ProductStickyAddToCartForm__AddToCart');
  
      addToCartButton.setAttribute('disabled', 'disabled');
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
  
      fetch(window.routes.cartAddUrl + '.js', {
        body: JSON.stringify(themegoal.components.Form.serialize(formElement)),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' 
        }
      }).then(function (response) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
  
        if (response.ok) {
          if (window.theme.cartType == "page") {
            window.location.href = window.routes.cartUrl;
            // return; 
          }else{
            addToCartButton.removeAttribute('disabled');
            response.json().then(function (data) {
              _this.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: _this.currentVariant,
                  quantity: parseInt(_this.querySelector('[name="quantity"]').value),
                  cartItemKey: data.key
                }
              }));
            });
          }
        } else {
          response.json().then(function (content) {
            var errorMessageElement = document.createElement('div');
            errorMessageElement.className = 'Alert Alert--danger';
            if (typeof content['description'] === 'object') {
              errorMessageElement.innerHTML = content['message'];
            }else{
              errorMessageElement.innerHTML = content['description'];
            }
            addToCartButton.removeAttribute('disabled');
            addToCartButton.insertAdjacentElement('beforeBegin', errorMessageElement);
            setTimeout(function () {
              errorMessageElement.remove();
            }, 8000);
          });
        }
      });
  
      event.preventDefault();
    }
  }
  
  customElements.define('product-sticky-add-to-cart', TG_ProductStickyAddToCart);
}